<template>
    <div
        v-if="isVisible"
        class="fixed border-2 border-ai rounded-lg shadow-lg z-50 bg-ai-secondary overflow-hidden"
        :style="{ top: `${position.y}px`, left: `${position.x}px` }"
    >
        <button
            class="w-full px-4 py-2 hover:bg-ai-hover bg-ai transition-colors duration-200 text-ai-inverse flex items-center gap-2"
            @click="handleAskLumi"
        >
            <img src="@/vue/icons/design-system/logos/lumi-purple-24.png" alt="Lumi" class="w-6 h-6">
            <span class="font-medium">{{ translate('general.ai.ask-lumi') }}</span>
        </button>
    </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import { useTranslationsStore } from '@/vue/stores/translationsStore'

const { translate } = useTranslationsStore()

const isVisible = ref(false)
const position = ref({ x: 0, y: 0 })
const selectedText = ref('')

const handleContextMenu = (event: MouseEvent) => {
    const selection = window.getSelection()
    if (selection && selection.toString().trim()) {
        event.preventDefault()
        selectedText.value = selection.toString().trim()
        position.value = {
            x: event.clientX,
            y: event.clientY,
        }
        isVisible.value = true
    }
}

const handleClick = () => {
    isVisible.value = false
}

const handleAskLumi = () => {
    // Emit event to parent with selected text
    emit('ask-lumi', `What does "${selectedText.value}" mean?`)
    isVisible.value = false
}

const emit = defineEmits<{
    (e: 'ask-lumi', text: string): void
}>()

onMounted(() => {
    document.addEventListener('contextmenu', handleContextMenu)
    document.addEventListener('click', handleClick)
})

onUnmounted(() => {
    document.removeEventListener('contextmenu', handleContextMenu)
    document.removeEventListener('click', handleClick)
})
</script>
